<script setup>
        import { ref , onMounted,nextTick   } from 'vue';
        import axios from 'axios';

        const result = ref(null);
        const error = ref(null);

        const props = defineProps(['value']);

        const selectedGroup = ref(null);
        const selectedParkhouse = ref(null);
        const selectedTarif = ref(props.value);


        const anzeigeTarif = ref(null);

        const emit = defineEmits(['tarifValue']);

        function submit() {
            emit('tarifValue', selectedTarif.value);
        }

        async function getData(){
            result.value = null;
            error.value = null;

            await axios.get("/tarifselect")
            .then(function (response) {
                result.value = response;
            }).catch(function (error) {
                error.value = error;
            });
        }

        onMounted(() => {
            getData();


        })



        const groups = ref(new Set());
        // create a set of groups and select a group if no group is selected
        function getGroups(){
            if( result.data != 'undefined'){
                groups.value.clear;
                result.value.data.forEach(element => {
                    groups.value.add(element["group"]);
                    if( selectedGroup.value  == null && element["tarif"] == selectedTarif.value){
                        selectedGroup.value = element["group"];
                    }
                });

                return Array.from(groups.value).sort();
            }
            return [];
        }

        const parkhouses = ref(new Set());
        // create a set of parkhouses depending on selected group. Select a parkhouse if no parkhouse is selected
        function getParkhouses(){

            if( result.data != 'undefined'){
                parkhouses.value.clear();

                result.value.data.forEach(element => {

                    if(element["group"] == selectedGroup.value){

                        parkhouses.value.add([element["parkhouse"], element["name"]]);
                        if (selectedParkhouse.value  == null && element["tarif"] == selectedTarif.value){
                            selectedParkhouse.value = element["name"];
                        }
                    }


                });

                return Array.from(parkhouses.value).sort();
            }
            return [];

        }


        const tarifs = ref(new Set());
        // create a set of tarif depending on the selected group + parkhouse. Select a tarif if no tarif is selected
        function getTarifs(){
            if( result.data != 'undefined'){
                tarifs.value.clear();

                result.value.data.forEach(element => {
                    if(element["name"] == selectedParkhouse.value && element["group"] == selectedGroup.value){
                        tarifs.value.add(element["tarif"]);
                    };

                });

                return Array.from(tarifs.value).sort();
            }



            return [];
        }

        // autoselect values if selected values are changed
        async function updateSelected(value,select){
            let selectGroup = document.getElementById("selectGroup");
            let selectParkhouse = document.getElementById("selectParkhouse");
            let selectTarif = document.getElementById("selectTarif");
          if(select == 1){

                selectedGroup.value = value;


                await nextTick();
                if(selectParkhouse.children.length > 0){
                    selectedParkhouse.value = selectParkhouse.children[0].value ;
                }

                await nextTick();
                if(selectTarif.children.length > 0){
                    selectedTarif.value = selectTarif.children[0].value ;
                }


            } else if (select == 2){
                selectedParkhouse.value =value;
                await nextTick();
                selectedTarif.value = selectTarif.children[0].value ;

            } else if (select == 3){
                if(selectTarif.value == '' && selectedTarif.value.length > 0 ){
                    selectTarif.value = selectedTarif.value;
                }
                selectedTarif.value =value;


            }



            if( selectTarif.selectedIndex >= 0){
                // if nothing is selected visually, automatically select based on current Tarif
                    if(selectGroup.selectedIndex < 0 || selectParkhouse.selectedIndex < 0){
                        result.value.data.forEach(element => {

                            if(element["tarif"] == selectTarif.value){
                                for(var i = 0; i < selectGroup.children.length; i++){
                                    if( selectGroup.children[i].value == element["group"]){
                                        selectGroup.selectedIndex = i;
                                    }
                                }
                                console.log(selectParkhouse.children.length);
                                for(var i = 0; i < selectParkhouse.children.length; i++){

                                    if( selectParkhouse.children[i].value == element["name"]){
                                        selectParkhouse.selectedIndex = i;

                                    }
                                }
                            }

                        })

                    }


                // values that is shown to the user
                anzeigeTarif.value = selectGroup.children[selectGroup.selectedIndex].innerHTML
                            + " - " + selectParkhouse.children[selectParkhouse.selectedIndex].innerHTML
                            + " - " + selectTarif.children[selectTarif.selectedIndex].innerHTML;
            }


        }



</script>

<template>
    <div v-if="result!=null">


        <h4 style="margin-top: -5px;"> Selektierter Tarif:   </h4> <h5 style="margin-top: -5px;">{{ anzeigeTarif == null ? "------":  anzeigeTarif}}</h5>



        <select id="selectGroup" value={{selectedGroup}} @change="updateSelected($event.target.value,1)" size="7"  class="form-select">
            <option v-for="item in getGroups()" :value=item> {{item}}</option>
        </select>
        <select id="selectParkhouse"  value={{selectedParkhouse}} @change="updateSelected($event.target.value,2)" style="margin-top: 10px;"  class="form-select" size="7" >
            <option v-for="item in getParkhouses()" :value=item[1]> {{item[1]}}</option>
        </select>
        <select id="selectTarif" value={{selectedTarif}} @change="updateSelected($event.target.value,3)" style="margin-top: 10px;" class="form-select" size="7" >
            <option v-for="item in getTarifs()" :value=item >  {{item}}</option>
        </select>

        <button class="btn btn-primary" style="float: right; margin-top: 5px" type="submit" @click.prevent="submit" @click="submit()">
            OK
            </button>




    </div>





</template>
